module.exports = __webpack_public_path__ + "static/media/chat.9d12794d.svg";